module.exports = __webpack_public_path__ + "static/img/3.3c3590e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/eng/3.png
// module id = g0BY
// module chunks = 0